export const MOBILE_MAX_WIDTH = 992

export const BUYER_VIEW_QUERY_PARAM = 'view'
export const BUYER_VIEW_QUERY_VALUE = 'buyer'
export const BUYER_VIEW_ACCOUNT_ID = 2

export const BUYER_MODE_EXIT_REASON = {
  SPAM_CONVERSATION: 'spam conversation',
  NON_BUYER_VIEW: 'non-buyer view',
  NO_CONVERSATION: 'no conversation',
  CONVERSATION_403: 'conversation 403',
} as const
